import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import DashboardChart from './DashboardChart';

import {
    getData,
    getLabelXAxes
} from './DashboardChart.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    labels: getLabelXAxes,
    metricsData: getData
});

export default connect(
    (state) => ({
        ...mapStateToPropsSelectors(state),
        loading: state.dashboard.last.loading,
        parameters: state.dashboard.last.parameters,
    }),
    () => ({})
)(DashboardChart);
